import { makeAutoObservable } from 'mobx'
import Settings from '../components/settings'
import * as _ from 'lodash/fp'

export class ValidateCouponController {

  couponTitle = null

   /**
   * @returns {ValidateCartController}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new ValidateCouponController()
    }
    return this.instance
  }

  constructor() {
    makeAutoObservable(this)
  }

  async validate(coupon) {
    const validation = await this.validateCoupon(coupon)

    this.couponTitle = validation.title ?? coupon

    return validation.valid ?? false
  }

  get isAllValid() {
    let isAllValid = _.pipe(
      () => this.validation_data ?? {},
      Object.values,
      _.all(eg => {
        let pp = _.pipe(
          () => eg,
          eg => eg.participants ?? {},
          Object.values,
          _.all(p => p.valid)
        )
        return eg.valid && pp()
      })
    )
    return isAllValid()
  }

  async validateCoupon(coupon) {
    const response = await fetch(
      Settings.getSetting('cart/validation/coupon', 'cart-overview'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({coupon: coupon })
      }
    ).then(response => response.json())
    return response
  }
}
